export default "__VITE_ASSET__BTagLP6W__"